import { createActions } from './createActions.ts';
import { deleteActions } from './deleteActions.ts';
import { favoriteActions } from './favoriteActions.ts';
import { fetchActions } from './fetchActions.ts';
import { insertCountActions } from './insertCountActions.ts';
import { shareActions } from './shareActions.ts';
import { templateGalleryActions } from './templateGalleryActions.ts';
import { updateActions } from './updateActions.ts';

/**
 * Combined actions object for the snippets store.
 * Actions are grouped by concern for better organization and testability:
 * - fetchActions: Data fetching and cache management
 * - createActions: Snippet creation and duplication with UI integration (flags, quick insert)
 * - deleteActions: Snippet deletion (API + local state; pass editorAPI in options for quick insert removal)
 * - updateActions: Snippet update (API + local state; pass editorAPI in options for quick insert removal)
 * - favoriteActions: Snippet favorite (API + local state)
 * - shareActions: Share/unshare with error flag UI
 * - insertCountActions: Record snippet insert (API + local insertCount increment)
 * - templateGalleryActions: Template gallery Block tab state (selected snippet)
 */
export const actions = {
	...fetchActions,
	...createActions,
	...deleteActions,
	...updateActions,
	...favoriteActions,
	...shareActions,
	...insertCountActions,
	...templateGalleryActions,
};
